import React from 'react';
export var CrossIcon = function CrossIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    clipRule: "evenodd",
    fill: "currentColor",
    fillRule: "evenodd",
    focusable: "false",
    strokeLinejoin: "round",
    viewBox: "0 0 10 10",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "6 5 10 9 9 10 5 6 1 10 0 9 4 5 0 1 1 0 5 4 9 0 10 1"
  }));
};